import './filtertags.less'

import React from 'react'
import {style} from 'util/style'

const styles = style('filtertags', ['item'])

export type FiltertagsItemType = {
	key: string
	label: string
}

export const Filtertags: React.FC<{
	tags: Array<FiltertagsItemType>
	filters: Array<string>
	toggleTag: (key: string) => void
}> = ({tags, filters, toggleTag}) => {
	if (tags.length === 0) return null

	return (
		<div className={styles()}>
			{tags
				.sort((a, b) => {
					if (a.label < b.label) {
						return -1
					}
					if (a.label > b.label) {
						return 1
					}
					// names must be equal
					return 0
				})
				.map((tag, i) => (
					<FiltertagsItem
						label={tag.label}
						onToggle={() => toggleTag(tag.key)}
						active={!!filters.includes(tag.key)}
					/>
				))}
		</div>
	)
}

export const FiltertagsItem: React.FC<{
	label: string
	onToggle: () => void
	active: boolean
}> = ({label, onToggle, active}) => {
	if (!label) return null

	return (
		<a onClick={onToggle} className={styles.item.is({active})}>
			<span className={styles.item('text')}>{label}</span>
		</a>
	)
}
